import {
  SHOW_MODAL_GIA_HAN_NOPHAITHU,
  POST_GIA_HAN_NOPHAITHU,
  POST_GIA_HAN_NOPHAITHU_SUCCESS,
  POST_GIA_HAN_NOPHAITHU_FAILURE,
} from "actions/GiaHanNoPhaiThu/actionTypes";

const initialState = {
  showGiaHanNoPhaiThu: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
};

const showModalGiaHanNoPhaiThu = (state, action) => {
  return {
    ...state,
    showGiaHanNoPhaiThu: !state.showGiaHanNoPhaiThu,
  };
};

const postGiaHanNoPhaiThu = (state, action) => ({
  ...state,
  postGiaHanNoPhaiThu: true,
});

const postGiaHanNoPhaiThuSuccess = (state, action) => {
  return {
    ...state,
    postGiaHanNoPhaiThu: false,
    objList: action.payload,
  };
};

const postGiaHanNoPhaiThuFailed = (state, action) => ({
  ...state,
  postGiaHanNoPhaiThu: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL_GIA_HAN_NOPHAITHU:
      return showModalGiaHanNoPhaiThu(state, action);
    case POST_GIA_HAN_NOPHAITHU:
      return postGiaHanNoPhaiThu(state, action);
    case POST_GIA_HAN_NOPHAITHU_SUCCESS:
      return postGiaHanNoPhaiThuSuccess(state, action);
    case POST_GIA_HAN_NOPHAITHU_FAILURE:
      return postGiaHanNoPhaiThuFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
